import { useMutation } from "@apollo/client";
import { Button } from "@blueprintjs/core";
import _ from "lodash";
import { useState } from "react";
import { Article, ArticlePriceTier } from "../../../../api/schema";
import { UserLanguage } from "../../../../lang/lang";
import {
  DeleteArticlePriceTierMutation,
  DeleteArticlePriceTierResponse,
} from "../../helper/graphql";
import { CreatePriceRow } from "./CreatePriceRow";
import { PriceRow } from "./PriceRow";

export const PriceTier = (props: {
  tier: ArticlePriceTier | null;
  article: Article;
  on_changed: () => void;
}) => {
  const [create_price_visible, set_create_price_visible] = useState(false);

  const [delete_price_tier] = useMutation<DeleteArticlePriceTierResponse>(
    DeleteArticlePriceTierMutation
  );
  const delete_tier = () => {
    if (!props.tier) return;

    console.log(`deleting price tier`, props.tier);

    delete_price_tier({ variables: { id: props.tier.id } }).then((res) => {
      console.log("delete_price_tier", res);
      if (res.data) props.on_changed();
    });
  };

  if (props.tier === null) return <div />;

  return (
    <div style={{ marginTop: 15 }}>
      <div>
        {_(props.tier.prices)
          .sortBy(["quantity"], ["asc"])
          .value()
          .map((price) => (
            <PriceRow
              key={price.id}
              price={price}
              price_tier={props.tier}
              on_changed={props.on_changed}
            />
          ))}
      </div>
      <div>
        <CreatePriceRow
          article={props.article}
          on_created={() => {
            set_create_price_visible(false);
            props.on_changed();
          }}
          on_cancel={() => set_create_price_visible(false)}
          price_tier={props.tier}
          visible={create_price_visible}
        />
      </div>
      <div style={{ marginTop: 15 }}>
        <Button
          intent="primary"
          text={
            UserLanguage().data.article.price_information.price.create_label
          }
          onClick={() => set_create_price_visible(true)}
          disabled={create_price_visible}
        />
        <Button
          style={{ float: "right" }}
          intent="danger"
          text={UserLanguage().data.article.price_information.price_tier.delete_label(
            props.tier.tier
          )}
          disabled={props.tier.prices.length > 0}
          onClick={delete_tier}
        />
      </div>
    </div>
  );
};
